export type Writeable<T extends object> = {
  -readonly [K in keyof T]: T[K];
};

export type RequiredKeys<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export type OptionalKeys<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

export function makeEnsureType<T>() {
  return function ensureType(value: T) {
    return value;
  };
}
